export default __webpack_public_path__ + "static/media/explainer_lightning.d5ee4122.png";